module.exports = __webpack_public_path__ + "static/media/success.ed4329ee.png";